var exports = {
  "k": "xaee3c4fa--79a61a--container",
  "v": "xaee3c4fa--79a61a--tabs",
};

module.exports = exports;
